export const IconLocation = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 25"
      {...props}
    >
      <mask
        id="IconLocation_svg__a"
        width={24}
        height={25}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 .242h24v24H0z" />
      </mask>
      <g mask="url(#IconLocation_svg__a)">
        <path d="M12 19.592q3.05-2.8 4.525-5.088T18 10.442q0-2.726-1.738-4.463T12 4.242 7.738 5.979Q6 7.716 6 10.442q0 1.774 1.475 4.062Q8.95 16.791 12 19.592m0 1.975a2.1 2.1 0 0 1-.7-.125 1.8 1.8 0 0 1-.625-.375A39 39 0 0 1 7.8 18.142q-1.25-1.425-2.087-2.763t-1.275-2.575T4 10.442q0-3.75 2.412-5.975Q8.826 2.24 12 2.242t5.587 2.225T20 10.442q0 1.125-.437 2.362-.438 1.237-1.275 2.575a22 22 0 0 1-2.088 2.763 39 39 0 0 1-2.875 2.925 1.8 1.8 0 0 1-.625.375 2.1 2.1 0 0 1-.7.125m0-9.325q.825 0 1.412-.588.588-.588.588-1.412 0-.825-.588-1.413A1.93 1.93 0 0 0 12 8.242q-.825 0-1.412.587A1.93 1.93 0 0 0 10 10.242q0 .824.588 1.412.587.588 1.412.588" />
      </g>
    </svg>
  );
};
